var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinistriesiconcbdfddde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11310_23656)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F5F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11310_23656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.876 8V23.4286H5V44H19.876H34.7521V8H19.876ZM10.4545 34.9388H6.98347V31.5102H10.4545V34.9388ZM10.4545 28.5714H6.98347V24.898H10.4545V28.5714ZM17.1488 34.9388H13.4298V31.5102H16.9008V34.9388H17.1488ZM17.1488 28.5714H13.4298V24.898H16.9008V28.5714H17.1488ZM26.0744 26.8571H22.3554V23.1837H25.8264V26.8571H26.0744ZM26.0744 20.2449H22.3554V16.5714H25.8264V20.2449H26.0744ZM26.0744 13.6327H22.3554V9.95918H25.8264V13.6327H26.0744ZM32.5207 26.8571H29.0496V23.1837H32.5207V26.8571ZM32.5207 20.2449H29.0496V16.5714H32.5207V20.2449ZM32.5207 13.6327H29.0496V9.95918H32.5207V13.6327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.876 8V23.4286H5V44H19.876H34.7521V8H19.876ZM10.4545 34.9388H6.98347V31.5102H10.4545V34.9388ZM10.4545 28.5714H6.98347V24.898H10.4545V28.5714ZM17.1488 34.9388H13.4298V31.5102H16.9008V34.9388H17.1488ZM17.1488 28.5714H13.4298V24.898H16.9008V28.5714H17.1488ZM26.0744 26.8571H22.3554V23.1837H25.8264V26.8571H26.0744ZM26.0744 20.2449H22.3554V16.5714H25.8264V20.2449H26.0744ZM26.0744 13.6327H22.3554V9.95918H25.8264V13.6327H26.0744ZM32.5207 26.8571H29.0496V23.1837H32.5207V26.8571ZM32.5207 20.2449H29.0496V16.5714H32.5207V20.2449ZM32.5207 13.6327H29.0496V9.95918H32.5207V13.6327Z",
    fill: "url(#paint0_linear_11310_23656)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.876 8V23.4286H5V44H19.876H34.7521V8H19.876ZM10.4545 34.9388H6.98347V31.5102H10.4545V34.9388ZM10.4545 28.5714H6.98347V24.898H10.4545V28.5714ZM17.1488 34.9388H13.4298V31.5102H16.9008V34.9388H17.1488ZM17.1488 28.5714H13.4298V24.898H16.9008V28.5714H17.1488ZM26.0744 26.8571H22.3554V23.1837H25.8264V26.8571H26.0744ZM26.0744 20.2449H22.3554V16.5714H25.8264V20.2449H26.0744ZM26.0744 13.6327H22.3554V9.95918H25.8264V13.6327H26.0744ZM32.5207 26.8571H29.0496V23.1837H32.5207V26.8571ZM32.5207 20.2449H29.0496V16.5714H32.5207V20.2449ZM32.5207 13.6327H29.0496V9.95918H32.5207V13.6327Z",
    fill: "url(#paint1_linear_11310_23656)",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11310_23656",
    x1: 34.7521,
    y1: 44,
    x2: -0.603641,
    y2: 14.7804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11310_23656",
    x1: 5,
    y1: 8,
    x2: 39.8085,
    y2: 37.3258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11310_23656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11310_23656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 36,
    fill: "white",
    transform: "translate(5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistriesiconcbdfddde);
export default __webpack_public_path__ + "static/media/ministriesicon.cbdfddde.96a536fe833b7f14cae6b366720bc477.svg";
export { ForwardRef as ReactComponent };